export type ThemeMode = 'dark' | 'light';

/** Dark is the default. A light theme stays available behind an explicit toggle. */
export const DEFAULT_THEME_MODE: ThemeMode = 'dark';

export const THEME_MODE_STORAGE_KEY = 'stock.bo.themeMode';
